import { gql } from 'apollo-angular';

export const RESEND_EVENT_MUTATION = gql`
mutation resendEvent($id: UUID) {
  resendEvent(id: $id)
}
`;

export const CLOSE_EVENT_MUTATION = gql`
mutation closeEvent($id: UUID) {
  closeEvent(id: $id)
}
`;
